import _defineProperty from "/app/node_modules/.pnpm/next@12.3.3_4afada721a4a39e35a1a66028f2134fd/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { InputText, Button, Card, Cell, Icon, Spacer, Text } from '@vinted/web-ui';
import { renderValidation } from 'components/Input';
import useFormValidationMessage from 'hooks/useFormValidationMessage';
import useTranslate from 'hooks/useTranslate';
import { resetPassword } from 'data/api/account';
import useDataDomeCaptcha from 'hooks/useDatadomeCaptcha';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TRANSLATION_PREFIX = 'auth.forgot_password';

const ResetPassword = () => {
  const {
    register,
    handleSubmit,
    getValues,
    formState: {
      isSubmitting,
      errors
    }
  } = useForm();
  const translate = useTranslate(TRANSLATION_PREFIX);
  const getErrorMessage = useFormValidationMessage(errors, "".concat(TRANSLATION_PREFIX, ".fields"));
  const {
    0: showSuccess,
    1: setShowSuccess
  } = useState(false);

  async function handleFormSubmit(_ref) {
    let {
      email
    } = _ref;
    await resetPassword({
      email
    });
    setShowSuccess(true);
  }

  useDataDomeCaptcha(() => {
    handleFormSubmit(getValues());
  });
  return /*#__PURE__*/_jsxs("form", {
    onSubmit: handleSubmit(handleFormSubmit),
    children: [/*#__PURE__*/_jsx("div", {
      className: "u-ui-padding-horizontal-large",
      children: /*#__PURE__*/_jsx(Text, {
        id: "auth_modal_title",
        text: translate('title'),
        type: Text.Type.Heading,
        width: Text.Width.Parent,
        alignment: Text.Alignment.Center
      })
    }), /*#__PURE__*/_jsx(Spacer, {
      size: Spacer.Size.Large
    }), showSuccess && /*#__PURE__*/_jsx("div", {
      className: "u-ui-padding-horizontal-large",
      children: /*#__PURE__*/_jsx(Card, {
        children: /*#__PURE__*/_jsx(Cell, {
          prefix: /*#__PURE__*/_jsx(Icon, {
            name: "check-circle-filled",
            color: Icon.Color.Green
          }),
          body: translate('success_note')
        })
      })
    }), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsx(InputText, _objectSpread(_objectSpread({}, register('email', {
      required: true
    })), {}, {
      placeholder: translate('fields.email.title'),
      validation: renderValidation(getErrorMessage('email')),
      uncontrolled: true
    })), /*#__PURE__*/_jsx(Cell, {
      children: /*#__PURE__*/_jsx(Button, {
        text: translate('actions.submit'),
        type: Button.Type.Submit,
        styling: Button.Styling.Filled,
        disabled: isSubmitting,
        isLoading: isSubmitting
      })
    })]
  });
};

export default ResetPassword;